<main class="content">
  <div class="tools-row">
    <div class="tools-row-main">
      <div class="breadcrumbs">
        <span>Inicio</span>
        <lucide-angular name="chevron-right"></lucide-angular>
        <span>Link</span>
        <lucide-angular name="chevron-right"></lucide-angular>
        <strong>Postular</strong>
      </div>

      <a
        *ngIf="!mostrarFiltrosPostulaciones"
        [href]="mesaAyudaUrl || '#'"
        class="help-link"
        target="_blank"
        rel="noopener noreferrer"
        (click)="abrirMesaAyuda($event)"
      >
        Mesa de Ayuda ANID
      </a>
    </div>
  </div>

  <section class="card">
    <h2>Postulaci&oacute;n Concursos</h2>
    <p class="welcome">&iexcl;Te damos la bienvenida a tu espacio de gesti&oacute;n de concursos!</p>
    <p class="subtitle">Postula, haz seguimiento y descubre nuevos concursos en un solo lugar.</p>

    <ng-container *ngIf="mostrarFiltrosPostulaciones; else filtrosInicioTpl">
      <div class="filters postulaciones-filters">
        <label>
          <span>ID Postulaci&oacute;n</span>
          <input
            [(ngModel)]="filtros.idPostulacion"
            type="text"
            placeholder="Ej: C-001"
            (input)="aplicarFiltros()"
          />
        </label>
        <label>
          <span>Subdirecci&oacute;n</span>
          <input
            [(ngModel)]="filtros.subdireccion"
            type="text"
            placeholder="Buscar subdirecci&oacute;n"
            (input)="aplicarFiltros()"
          />
        </label>
        <label>
          <span>Convocatoria</span>
          <input
            [(ngModel)]="filtros.convocatoria"
            type="text"
            placeholder="Buscar convocatoria"
            (input)="aplicarFiltros()"
          />
        </label>
        <button type="button" class="clear-btn" (click)="limpiarFiltros()">Limpiar</button>
      </div>
    </ng-container>

    <ng-template #filtrosInicioTpl>
      <div class="search-row">
      <input
        [(ngModel)]="terminoBusqueda"
        type="text"
        placeholder="Buscar por palabra o dato espec&iacute;fico"
        (keyup.enter)="buscar(terminoBusqueda)"
      />
      <button type="button" class="search-btn" (click)="buscar(terminoBusqueda)">
        Buscar <lucide-angular name="plus-circle"></lucide-angular>
      </button>
      <button type="button" class="clear-btn" (click)="limpiarFiltros()">Limpiar</button>
      </div>
    </ng-template>
    <p class="search-message" *ngIf="mensajeBusqueda">{{ mensajeBusqueda }}</p>

    <div class="filters-header" *ngIf="!mostrarFiltrosPostulaciones">
      <span>ID Postulaci&oacute;n</span>
      <span>Subdirecci&oacute;n</span>
      <span>Convocatoria</span>
    </div>

    <div class="filters" *ngIf="!mostrarFiltrosPostulaciones">
      <input
        [(ngModel)]="idPostulacionFiltro"
        type="text"
        placeholder="Ej: C-001"
        (input)="aplicarFiltros()"
      />
      <select [(ngModel)]="subdireccionSeleccionada" (change)="aplicarFiltros()">
        <option value="Todas">Todas</option>
        <option *ngFor="let subdireccion of subdirecciones" [value]="subdireccion">{{ subdireccion }}</option>
      </select>
      <select [(ngModel)]="convocatoriaSeleccionada" (change)="aplicarFiltros()">
        <option value="Todas">Todas</option>
        <option *ngFor="let convocatoria of convocatorias" [value]="convocatoria">{{ convocatoria }}</option>
      </select>
    </div>

    <div class="advanced-row" *ngIf="!mostrarFiltrosPostulaciones">
      <div class="sort">
        <label for="ordenSelector">Ordenado por:</label>
        <select id="ordenSelector" [(ngModel)]="ordenSeleccionado" (change)="aplicarFiltros()">
          <option value="inicio_desc">Fecha de inicio (desc)</option>
          <option value="inicio_asc">Fecha de inicio (asc)</option>
          <option value="fin_desc">Fecha de fin (desc)</option>
          <option value="fin_asc">Fecha de fin (asc)</option>
        </select>
      </div>
    </div>

    <div class="tags" *ngIf="!mostrarFiltrosPostulaciones && filtrosActivos.length > 0">
      <span *ngFor="let filtro of filtrosActivos">
        {{ filtro.label }}
        <button type="button" class="chip-close" [attr.aria-label]="'Quitar filtro ' + filtro.label" (click)="quitarFiltro(filtro.key)">
          &times;
        </button>
      </span>
    </div>

    <div class="table-wrap" *ngIf="resultadosPaginados.length > 0; else sinResultadosConcursosTpl">
      <table class="table">
        <thead>
          <tr>
            <th>Concurso <lucide-angular name="funnel"></lucide-angular></th>
            <th>Subdirecci&oacute;n</th>
            <th>Convocatoria</th>
            <th>Fecha apertura</th>
            <th>Fecha cierre</th>
            <th>Estado</th>
            <th>Acciones</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let concurso of resultadosPaginados">
            <td>{{ concurso.nombre }}</td>
            <td>{{ concurso.subdireccion }}</td>
            <td>{{ concurso.convocatoria }}</td>
            <td>{{ formatearFecha(concurso.fechaApertura) }}</td>
            <td>{{ formatearFecha(concurso.fechaCierre) }}</td>
            <td><span class="badge" [ngClass]="estadoConcursoClase(concurso.estado)">{{ estadoConcursoLabel(concurso.estado) }}</span></td>
            <td class="actions">
              <div class="actions-wrap">
                <button
                  type="button"
                  class="action-text-btn"
                  aria-label="Ver caja concursal"
                  title="Ver caja concursal"
                  (click)="verConcurso(concurso)"
                >
                  Ver caja concursal
                </button>
                <button
                  *ngIf="puedeIniciarPostulacion(concurso)"
                  type="button"
                  class="action-text-btn action-primary"
                  aria-label="Iniciar postulaci&oacute;n"
                  title="Iniciar postulaci&oacute;n"
                  (click)="iniciarPostulacion(concurso)"
                >
                  Iniciar postulaci&oacute;n
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <ng-template #sinResultadosConcursosTpl>
      <app-empty-filter-state></app-empty-filter-state>
    </ng-template>
    <app-table-pagination
      [page]="paginaActual"
      [pageSize]="tamanoPagina"
      [totalItems]="resultados.length"
      itemLabel="concursos"
      [pageSizeOptions]="tamanosPaginaDisponibles"
      (pageChange)="cambiarPagina($event)"
      (pageSizeChange)="cambiarTamanoPaginaDesdePaginador($event)"
    ></app-table-pagination>

  </section>
</main>

<footer class="footer-note">
  Para conocer el detalle de la versi&oacute;n actual y versiones anteriores, revise aqu&iacute;
</footer>

